import React from "react";

export const HashIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.87 2.08a.75.75 0 0 1 .55.9L8.78 6h3.44l.72-3.32a.75.75 0 0 1 1.46.32l-.63 2.92-.02.08H16a.75.75 0 0 1 0 1.5h-2.57l-.87 4H15a.75.75 0 0 1 0 1.5h-2.76l-.72 3.32a.75.75 0 0 1-1.46-.32l.63-2.92.02-.08H7.27l-.72 3.32a.75.75 0 1 1-1.46-.32l.63-2.92.02-.08H4a.75.75 0 0 1 0-1.5h2.06l.87-4H5a.75.75 0 0 1 0-1.5h2.25l.72-3.32a.75.75 0 0 1 .9-.55ZM8.46 7.5l-.87 4h3.44l.87-4H8.46Z"
      clipRule="evenodd"
    />
  </svg>
);
